/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { push } from 'connected-react-router'

import $ from 'jquery'
// eslint-disable-next-line
import {
  cloneDeep,
  forEach,
  size,
  map,
  find
} from 'lodash'

import {
  CHANGE_ROUTE,
  SORT_NAV,
  HIGHLIGHT_NAVBAR_SECTION
} from './action-types'
import { constants as L100Constants } from '../../constants';
import { toggleMenu, sortNav, highlightNavbarSection } from './actions'
import store, { dispatch } from '../../root/store'
import config from '../../config/app'

import UpcomingIcon from '../../assets/icons/nav_bar/schedule_visit.svg'
import VitalSignsIcon from '../../assets/icons/current_report/current_vital_signs.svg'
import CheckmarkIcon from '../../assets/icons/checkmark.svg'

// overwrite default state
const getCurrentMenu = defaultState => {
  const { app } = store.getState().containers
  const currentVisit = cloneDeep(app.get('currentVisit'))
  const upcomingVisit = cloneDeep(app.get('upcomingVisit'))
  const activeAssessment = cloneDeep(app.get('activeAssessment'))
  const user = app.get('user')

  let currentReportMenu

  if (
    user.visits.length <= 1 &&
    (!user.visits[0] || user.visits[0].status.completed === false)
  ) {
    currentReportMenu = cloneDeep(config.consentNav)
  } else {
    currentReportMenu = defaultState
  }

  if (upcomingVisit) currentReportMenu.isDisabled = false

  if (currentVisit === null) {
    if (upcomingVisit) {
      const routeBase = `/visits/${upcomingVisit.uuid}/assessments/consent`
      currentReportMenu.route = routeBase
      currentReportMenu.onClick = () =>
        dispatch(highlightNavbarSection('currentReport'))

      // change consent route to specific visit consent
      forEach(currentReportMenu.subItems, (item, index) => {
        item.route = `${routeBase}${item.route}`

        if (activeAssessment) {
          if (index > activeAssessment.farthestProgress - 1) {
            item.isDisabled = true
          } else if (index === activeAssessment.farthestProgress - 1) {
            item.isDisabled = false
          } else if (index < activeAssessment.farthestProgress - 1) {
            item.isDisabled = false
            item.icon = { src: CheckmarkIcon }
          }
        }
      })
      // hasSubmittedConsent add checkmark
    }
  } else {
    currentReportMenu = currentVisit
  }

  return currentReportMenu
}

const getUpcomingMenu = defaultState => {
  const { app } = store.getState().containers
  const upcomingVisit = cloneDeep(app.get('upcomingVisit'))
  const activeAssessments = cloneDeep(app.get('activeAssessments'))

  let upcomingVisitMenu

  if (upcomingVisit === null) {
    upcomingVisitMenu = defaultState
    upcomingVisitMenu.title = 'Schedule a Visit'
  } else {
    upcomingVisitMenu = upcomingVisit
    upcomingVisitMenu.title = 'Upcoming Visit'
    upcomingVisitMenu.icon = { src: UpcomingIcon }

    if (size(app.get('history')) > 0) {
      upcomingVisitMenu.subItems = {
        assessments: {
          title: 'Pre-Visit Assessments',
          route: `/visits/${upcomingVisit.uuid}/assessments`,
          subItems: {}
        }
      }

      const randomAssessment =
        activeAssessments !== null
          ? Object.getOwnPropertyNames(activeAssessments)[0]
          : ''
      if (
        activeAssessments !== null &&
        upcomingVisit.uuid === activeAssessments[randomAssessment]._meta.visitId
      ) {
        map(activeAssessments, (value, key) => {
          if (config.assessments.includes(value.title)) {
            upcomingVisitMenu.subItems.assessments.subItems[key] = value
            upcomingVisitMenu.subItems.assessments.subItems[
              key
            ]._meta.route = `/visits/${upcomingVisit.uuid}/assessments/${value.shortName}`
            upcomingVisitMenu.subItems.assessments.subItems[key]._meta.icon = {
              src: CheckmarkIcon
            }
          }
        })
      }
    }
  }

  return upcomingVisitMenu
}

const calculateSurveyProgress = activeAssessments => {
  let assessmentProgress = 0
  for (const key in activeAssessments) {
    if (key !== 'consent') {
      if (activeAssessments[key].completed) ++assessmentProgress
    }
  }
  return assessmentProgress
}

// overwrite default
const getHistoryMenu = defaultState => {
  const app = cloneDeep(store.getState().containers.app)
  const history = app.get('history')
  const activeVisit = app.get('activeVisit')
  const currentVisit = app.get('currentVisit')
  const activeAssessments = app.get('activeAssessments')
  const user = app.get('user')
  const upcomingVisit = app.get('upcomingVisit')
  let historyMenu

  if (size(history) < 1) {
    historyMenu = defaultState
    historyMenu.isDisabled = true
    historyMenu.title = 'Pre-Visit Assessments'
    historyMenu.icon = { src: VitalSignsIcon }

    const hasSubmittedConsent = user.consent.accepted !== L100Constants.notSet

    if (hasSubmittedConsent && upcomingVisit !== null) {
      historyMenu.isDisabled = false
      const baseRoute = `/visits/${upcomingVisit.uuid}/assessments`
      historyMenu.route = baseRoute
      historyMenu.subItems = cloneDeep(
        config.nav.items.history.subItems.assessments.subItems
      )
      forEach(historyMenu.subItems, (value, key) => {
        value.route = `${baseRoute}/${key}`
        if (activeAssessments) {
          const completedAssessments = calculateSurveyProgress(
            activeAssessments
          )

          // if (completedAssessments === 8) {
          //   historyMenu.icon = { src: CheckmarkIcon }
          // } else {
          historyMenu.icon = {
            text: `${completedAssessments}/8 ${!app.get('isMobile') ? 'completed' : ''
              }`
          }
          // }
          if (
            activeAssessments[key].percent > 0 &&
            activeAssessments[key].percent < 100
          ) {
            value.icon = {
              text: `${Math.floor(activeAssessments[key].percent)}% completed`
            }
          } else if (activeAssessments[key].percent === 0) {
            value.icon = { text: activeAssessments[key].timeToComplete }
          } else if (
            activeAssessments[key].percent === 100 &&
            activeAssessments[key].completed
          ) {
            value.icon = { src: CheckmarkIcon }
          } else if (
            activeAssessments[key].percent === 100 &&
            !activeAssessments[key].completed
          ) {
            value.icon = { text: 'Review & Submit' }
          }
        }
      })
    }
  } else {
    historyMenu = history
    let activeVisitMenu

    if (activeVisit !== null) {
      activeVisitMenu = find(historyMenu, { uuid: activeVisit.uuid })

      const isCurrentVisit =
        currentVisit && currentVisit.uuid === activeVisit.uuid

      if (activeVisitMenu) {
        let subItems
        if (
          !currentVisit ||
          !isCurrentVisit // dont show reports if this past visit is current visit
        ) {
          subItems = {
            reports: {
              title: 'Reports',
              route: `/visits/${activeVisit.uuid}/reports`,
              subItems: {}
            },
            assessments: {
              title: 'Pre-Visit Assessments',
              route: `/visits/${activeVisit.uuid}/assessments`,
              subItems: {}
            }
          }
        } else if (currentVisit && currentVisit.uuid === activeVisit.uuid) {
          subItems = {
            assessments: {
              title: 'Pre-Visit Assessments',
              route: `/visits/${activeVisit.uuid}/assessments`,
              subItems: {}
            }
          }
        }

        activeVisitMenu.subItems = subItems

        // populate reports

        if (!currentVisit || !isCurrentVisit) {
          map(activeVisit.reportCard, (value, key) => {
            if (config.reports.includes(value._meta.title)) {
              activeVisitMenu.subItems.reports.subItems[key] = value

              const {
                originalTitle
              } = activeVisitMenu.subItems.reports.subItems[key]._meta

              activeVisitMenu.subItems.reports.subItems[
                key
              ]._meta.route = `/visits/${activeVisit.uuid}/reports/${originalTitle}`
            }
          })
        }

        // populate assessments

        const randomAssessment =
          activeAssessments !== null
            ? Object.getOwnPropertyNames(activeAssessments)[0]
            : ''
        if (
          activeAssessments !== null &&
          activeVisit.uuid === activeAssessments[randomAssessment]._meta.visitId
        ) {
          map(activeAssessments, (value, key) => {
            if (config.assessments.includes(value.title)) {
              activeVisitMenu.subItems.assessments.subItems[key] = value
              activeVisitMenu.subItems.assessments.subItems[
                key
              ]._meta.route = `/visits/${activeVisit.uuid}/assessments/${value.shortName}`
              activeVisitMenu.subItems.assessments.subItems[key]._meta.icon = {
                src: CheckmarkIcon
              }
            }
          })
        }
        historyMenu[activeVisitMenu.uuid] = activeVisitMenu
      }
    }
  }

  return historyMenu
}

const getSortedMenu = () => {
  const { app } = store.getState().containers
  const user = cloneDeep(app.get('user'))
  const { items } = cloneDeep(config.nav) // default state
  const history = getHistoryMenu(items.history)
  const currentReport = getCurrentMenu(items.currentReport)
  const upcomingVisit = getUpcomingMenu(items.upcomingVisit)

  const isPreVisit =
    user.visits.length <= 1 &&
    (!user.visits[0] || user.visits[0].status.completed === false)

  if (isPreVisit) items.history = history
  else items.history.subItems = history
  items.currentReport = currentReport
  items.upcomingVisit = upcomingVisit

  return items
}

const middleware = () => next => action => {
  switch (action.type) {
    case CHANGE_ROUTE: {
      const { nav } = store.getState().containers
      const { route } = action.payload

      if (nav.get('isMenuToggled')) dispatch(toggleMenu())
      dispatch(sortNav())
      dispatch(push(route))
      $('.main-content div').scrollTop(0)
      return next(action)
    }

    case HIGHLIGHT_NAVBAR_SECTION: {
      const { nav } = store.getState().containers
      if (action.payload === nav.get('highlightedNavbarSection')) return

      return next(action)
    }

    case SORT_NAV: {
      const { app } = store.getState().containers
      if (app.get('user') === null) return

      const payload = getSortedMenu()
      action.payload = payload
      return next(action)
    }
    default:
      return next(action)
  }
}

export default middleware
